import { RouteName } from "@/router/types";
import { UserInfo } from "@/services/apiService/api.types";

export interface SettingsCardInfo {
  settingsCardTitle: SettingsTitle;
  icon?: NodeRequire;
  attachedRoute?: RouteName;
  requiresPin?: boolean;
  opensRightSideMenu?: boolean;
  rightSideMenuTitle?: SettingsTitle;
}

export interface SettingsState {
  settingsPageTitle: SettingsTitle;
  openPinOverlay: boolean;
  encodedPin: string;
  openRightSideMenu: boolean;
  activeCardIndex?: number;
  activeCardSection?: SettingsCardSections;
  rightSideMenuTitle: SettingsTitle;
  userToEdit?: UserInfo;
  confirmModalStatus: boolean;
  openConfirmModal: boolean;
  confirmModalMsg: string;
  channelCardCurrPos?: number;
  channelCardNewPos?: number;
}

export const enum SettingsActions {}

export const enum SettingsMutations {
  setSettingsPageTitle = "setSettingsPageTitle",
  setPinOverlay = "setPinOverlay",
  setEncodedPin = "setEncodedPin",
  setOpenRightSideMenu = "setOpenRightSideMenu",
  setActiveCardIndex = "setActiveCardIndex",
  setActiveCardSection = "setActiveCardSection",
  setRightSideMenuTitle = "setRightSideMenuTitle",
  setUserToEdit = "setUserToEdit",
  setConfirmModalStatus = "setConfirmModalStatus",
  setOpenConfirmModal = "setOpenConfirmModal",
  setConfirmModalMsg = "setConfirmModalMsg",
  setChannelCardCurrPos = "setChannelCardCurrPos",
  setChannelCardNewPos = "setChannelCardNewPos"
}

export const enum SettingsGetters {
  getSettingsPageTitle = "getSettingsPageTitle",
  getPinOverlay = "getPinOverlay",
  getEncodedPin = "getEncodedPin",
  getOpenRightSideMenu = "getOpenRightSideMenu",
  getActiveCardIndex = "getActiveCardIndex",
  getActiveCardSection = "getActiveCardSection",
  getRightSideMenuTitle = "getRightSideMenuTitle",
  getUserToEdit = "getUserToEdit",
  getConfirmModalStatus = "getConfirmModalStatus",
  getOpenConfirmModal = "getOpenConfirmModal",
  getConfirmModalMsg = "getConfirmModalMsg",
  getChannelCardCurrPos = "getChannelCardCurrPos",
  getChannelCardNewPos = "getChannelCardNewPos"
}

export enum SettingsCardSections {
  Profile = "Profile",
  Personal = "Personal",
  Other = "Other"
}

export interface SettingsTitle {
  heading?: string;
  subHeading?: string;
}

export const enum formPosMap {
  oldPin = "#oldPin",
  newPin = "#newPin",
  newPinConfirm = "#newPinConfirm",
  changePinBtn = "#changePinBtn"
}

export enum UpdateUserErrorProps {
  username = "username",
  first_name = "first_name",
  last_name = "last_name",
  old_password = "old_password",
  password = "password",
  password_confirm = "password_confirm",
  old_pin_code = "old_pin_code",
  pin_code = "pin_code",
  confirm_pin_code = "confirm_pin_code"
}

export interface ApiStorageMap {
  [key: string]: () => Promise<unknown>;
}
